import api from './index'
import { setCookie } from './cookies'

export async function createSimulation(contact) {
  const { data } = await api.post('/api/simulate', contact)
  setCookie('vid', data.vid)

  return data
}

export function updateSimulation(contact) {
  const { email, ...restContact } = contact
  return api.post(`/api/simulate/${restContact.id}`, restContact)
}
